import React from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import Layout from "../layout/Layout";
import { getCookie } from "../utils/helper";

interface PrivateRouteProps {
  component: React.ComponentType<any>;
  layout?: boolean;
  [key: string]: any;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  layout = true,
  ...rest
}) => {
  const { accounts, inProgress } = useMsal();

  const isAuthenticated =
    (accounts.length > 0 && inProgress === InteractionStatus.None) ||
    (getCookie("accessToken") && getCookie("username"));

  if (isAuthenticated) {
    if (layout) {
      return (
        <Layout>
          <Component {...rest} />
        </Layout>
      );
    }
    return <Component {...rest} />;
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default PrivateRoute;
